import { SERVICE_AREAS } from "@/lib/api";
import { MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";

export default function ServiceAreas({ compact=false }) {
  const { t } = useLang();
  return (
    <section id="areas" className={`${compact ? "" : "section-pad"} ${compact ? "" : "bg-ink-800/30"}`} data-testid="service-areas">
      <div className="mx-auto max-w-7xl px-5 md:px-8 py-12">
        <div className="text-xs font-bold uppercase tracking-[0.22em] text-ice-400">Coverage</div>
        <h2 className="mt-3 font-display text-3xl md:text-5xl font-black">{t("areas.title")}</h2>
        <p className="mt-3 text-silver-300 max-w-2xl">{t("areas.sub")}</p>

        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {Object.entries(SERVICE_AREAS).map(([region, cities], i) => (
            <div key={region} className="card-ink rounded-2xl p-6" data-testid={`region-${i}`}>
              <div className="flex items-center gap-2"><MapPin className="size-4 text-ice-400"/><h3 className="font-display text-lg font-bold">{region}</h3></div>
              <div className="mt-4 flex flex-wrap gap-2">
                {cities.map(c => (
                  <Link key={c} to={`/city/${encodeURIComponent(c.toLowerCase().replace(/ /g,"-"))}`}
                    className="text-xs px-3 py-1.5 rounded-full bg-white/5 hover:bg-ice-400/15 hover:text-ice-400 transition"
                    data-testid={`city-link-${c}`}>{c}</Link>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-3xl overflow-hidden ring-1 ring-white/10" data-testid="areas-map">
          <iframe
            title="Service area map"
            src="https://www.google.com/maps?q=San+Gabriel+Valley,+CA&hl=en&z=10&output=embed"
            className="w-full h-[360px]"
            loading="lazy"
            style={{ border: 0, filter: "invert(0.9) hue-rotate(180deg)" }}
          />
        </div>
      </div>
    </section>
  );
}
